import { render, staticRenderFns } from "./UiDialog.vue?vue&type=template&id=ed1b58d6&scoped=true"
import script from "./UiDialog.vue?vue&type=script&lang=js"
export * from "./UiDialog.vue?vue&type=script&lang=js"
import style0 from "./UiDialog.vue?vue&type=style&index=0&id=ed1b58d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1b58d6",
  null
  
)

export default component.exports